import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "position-absolute start-0 w-100 d-flex align-items-center",
  style: {"height":"150px","padding":"0px 40px","bottom":"40px"}
}
const _hoisted_2 = { class: "d-flex justify-content-between w-100" }
const _hoisted_3 = { style: {"line-height":"1.2"} }
const _hoisted_4 = {
  class: "text-muted",
  style: {"font-size":"10.2px","line-height":"1.2","display":"block"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("small", _hoisted_4, _toDisplayString(_ctx.$t(
                `project.previewAndReport.reportTypes.${_ctx.reportType}.footer.copyright`
              )), 1)
        ])
      ])
    ])
  ]))
}